import { useLocation } from "react-router-dom";
import en from "./en.json";
import ru from "./ru.json";
import home from "../_data/home.json";

const EN = { ...en, typewriter: home.typewriter, stats: home.stats, services: home.services, whyMe: home.whyMe, faq: home.faq };

/** "ru" on /ru (the Russian home page), "en" everywhere else */
export const useLang = () => {
  const { pathname } = useLocation();
  return pathname === "/ru" || pathname.startsWith("/ru/") ? "ru" : "en";
};

/** UI copy for the current language */
export const useCopy = () => (useLang() === "ru" ? ru : EN);

/** Renders "**highlighted**" parts of a string as accent spans */
export const rich = (text, years) =>
  text
    .replace("{years}", years)
    .split("**")
    .map((part, i) => (i % 2 ? <span key={i} className="hl">{part}</span> : part));
